
export default {

    global: {
        currency: '€',
        currency_decimals: 2,
        identificationType: 'DNI',
        minAverage: 6,
        maxAverage: 10,
        payment: {
            isCftEnabled: true
        },
        student_pays_enrollment: true,
    },
    chile: {
        currency: '$',
        currency_decimals: 0,
        identificationType: 'RUT',
        minAverage: 4,
        maxAverage: 7,
        payment: {
            isCftEnabled: false
        },
        student_pays_enrollment: true,
    },
    peru: {
        currency: 'S/',
        currency_decimals: 2,
        identificationType: 'DNI',
        minAverage: 13,
        maxAverage: 20,
        payment: {
            isCftEnabled: false
        },
        student_pays_enrollment: true,
    },
    mexico: {
        currency: 'MXN$',
        currency_decimals: 2,
        identificationType: 'CURP',
        minAverage: 6,
        maxAverage: 10,
        payment: {
            isCftEnabled: false
        },
        student_pays_enrollment: false,
    },

}